import { useCallback, useMemo } from 'react';
import { userOSHelper } from '@jarvis/react-portal-addons';
import { APP_URLS } from '../utils/constants';

const useOpenStoreForHpApp = () => {
  const hpAppUrl = useMemo(() => {
    const { userOSDetector } = userOSHelper;
    const os = userOSDetector() || '';
    let url = '';

    if (os.match(/Windows/i)) {
      url = APP_URLS.WINDOWS_APP_URL;
    } else if (os.match(/Mac/i)) {
      url = APP_URLS.MAC_APP_URL;
    } else if (os.match(/iOS/i)) {
      url = APP_URLS.IOS_APP_URL;
    } else if (os.match(/Android/i)) {
      url = APP_URLS.ANDROID_APP_URL;
    }

    return url;
  }, []);

  const openStoreForHpApp = useCallback(() => {
    if (hpAppUrl) {
      window.open(hpAppUrl, '_self');
    }
  }, [hpAppUrl]);

  return { openStoreForHpApp, hpAppUrl };
};

export default useOpenStoreForHpApp;
